// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2568 ? "locales-web-ru-po-json" : chunkId) + "." + {"1274":"f3d00cdb59e96d6db395","2107":"8956afb0562a25da11af","2568":"3408cd1381d5b3ea5d88"}[chunkId] + ".js";
};